import { IconClock16 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { FloatingLabel } from 'shared/components/FloatingLabel';
import { NBSP } from 'shared/constants';
import { selectIsEarlyAccessLabelEnabled } from 'shared/selectors/selectIsEarlyAccessLabelEnabled';

export const EarlyAccessLabelContainer = () => {
  const isEarlyAccessLabelEnabled = useSelector(selectIsEarlyAccessLabelEnabled);

  if (!isEarlyAccessLabelEnabled) {
    return null;
  }

  return (
    <FloatingLabel
      data-testid="EarlyAccessLabel"
      labelText="Ранний доступ"
      tooltipText={`Новые объявления от собственников,\nопубликованные в${NBSP}течение последних нескольких\nчасов. Просмотр контактов — платный`}
      color="decorative-accent-purple"
      backgroundColor="decorative-accent-lavender-transparent"
      icon={<IconClock16 color="decorative-accent-purple" />}
    />
  );
};
